import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  isVisible: false
}

const upgradeNotetakerSpotlightSlice = createSlice({
  name: 'upgradeNotetakerSpotlight',
  initialState,
  reducers: {
    showUpgradeNotetakerSpotlight: (state) => {
      state.isVisible = true
    },
    hideUpgradeNotetakerSpotlight: (state) => {
      state.isVisible = false
    }
  }
})

export const {
  reducer,
  actions: {
    showUpgradeNotetakerSpotlight,
    hideUpgradeNotetakerSpotlight
  }
} = upgradeNotetakerSpotlightSlice
